<template>
    <div>
        <v-carousel v-if="refId">
            <v-carousel-item :contain=!$vuetify.breakpoint.mobile v-for="(img, idx) in images" :key="idx" :src="img.src"
                             reverse-transition="fade-transition" transition="fade-transition">
            </v-carousel-item>
        </v-carousel>

        <!-- Fallback: display flower -->
        <div style="width:100%; height:200px; line-height:200px; text-align:center" v-else>
            <v-icon size="100">mdi-flower</v-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ImageCarousel',
        props: ['refId'],
        computed: {
            images() {
                if(this.$store.getters.imageList.filter(image => image.referenceId==this.refId).length == 0)
                    this.$store.dispatch('loadImageNEW', {type:'plant', refId:this.refId});
                return this.$store.getters.imageList.filter(image => image.referenceId==this.refId)
            }
        }
    };
</script>

<style scoped>

</style>
